<template>
  <div
    class="projects-map-legend justify-center absolute top-3 left-3 lg:top-7 lg:left-7 lg:w-64 z-20"
    :class="{'hidden lg:block': hideLegend}"
  >
    <ul class="bg-white p-3 lg:p-5 shadow-md rounded-sm mb-4">
      <li
        v-for="(legendItem, i) in legendData"
        :key="i"
        class="flex gap-2 lg:gap-3 items-center mb-2 lg:mb-4 last:mb-0"
      >
        <kf-image
          v-if="legendItem?.legendIcon"
          :src="legendItem.legendIcon"
          class="w-4 h-4 lg:w-8 lg:h-8"
          alt=""
        />
        <p
          v-if="legendItem?.name"
          class="mb-0 text-sm lg:text-base"
        >
          {{ legendItem.name }}
        </p>
      </li>
    </ul>
    <projects-autocomplete
      :locations="locations"
      :i18n="i18n"
      @zoom-to-location="handleZoomToLocation"
      @reset-map="handleResetMap"
    />
  </div>
</template>

<script>
import KfImage from '@/components/base/image/Image.vue';
import ProjectsAutocomplete from '@/components/projects/ProjectsAutocomplete.vue';

export default {
  name: 'KfProjectsLegend',
  components: {
    ProjectsAutocomplete,
    KfImage,
  },
  props: {
    legendData: {
      type: Array,
      default: () => [],
    },
    locations: {
      type: Array,
      default: () => [],
    },
    hideLegend: {
      type: Boolean,
      default: false,
    },
    i18n: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleZoomToLocation(location) {
      this.$emit('zoom-to-location', location);
    },
    handleResetMap() {
      this.$emit('reset-map',);
    }
  }
};
</script>

<style>
.projects-detail-meta {
  grid-row: span 1;
}

.project-detail-carousel {
  .carousel {
    .glide__track {
      @apply pl-0;
    }
  }
}

</style>


